export const SET_SUBJECT_SEARCH_FILTER = 'SET_SUBJECT_SEARCH_FILTER'
export const setSubjectSearchFilter = (id) => ({
    type: SET_SUBJECT_SEARCH_FILTER,
    payload: id,
})

export const SET_SCHOOL_YEAR_SEARCH_FILTER = 'SET_SCHOOL_YEAR_SEARCH_FILTER'
export const setSchoolYearSearchFilter = (id) => ({
    type: SET_SCHOOL_YEAR_SEARCH_FILTER,
    payload: id,
})

export const SET_LEVEL_SEARCH_FILTER = 'SET_LEVEL_SEARCH_FILTER'
export const setLevelSearchFilter = (id) => ({
    type: SET_LEVEL_SEARCH_FILTER,
    payload: id,
})

export const RESET_SEARCH_FILTERS = 'RESET_SEARCH_FILTERS'
export const resetSearchFilters = () => ({
    type: RESET_SEARCH_FILTERS,
})

export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE'
export const setSearchType = (type) => ({
    type: SET_SEARCH_TYPE,
    payload: { type },
})

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const setSearchTerm = (term) => ({
    type: SET_SEARCH_TERM,
    payload: { term },
})
